import { render } from "./ChatRoomShow.vue?vue&type=template&id=2105520c&scoped=true"
import script from "./ChatRoomShow.vue?vue&type=script&lang=js"
export * from "./ChatRoomShow.vue?vue&type=script&lang=js"

import "./ChatRoomShow.vue?vue&type=style&index=0&id=2105520c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2105520c"]])

export default __exports__